import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ConsentModel } from '../models/consent.model';
import { SettingsModel } from '../models/settings.model';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  constructor(private _http: HttpClient) {}

  settingsController = '/api/settings';
  getSettings(locationId: number): Observable<SettingsModel> {
    return this._http
      .get<SettingsModel>(`${this.settingsController}/all/${locationId}`)
      .pipe(map((data) => data));
  }

  getSettingsInStudentPortal(locationId: number): Observable<SettingsModel> {
    return this._http
      .get<SettingsModel>(`${this.settingsController}/all/${locationId}`)
      .pipe(map((data) => data));
  }

  getConsentLink(locationId: number): Observable<ConsentModel> {
    return this._http.get<ConsentModel>(
      `${this.settingsController}/consentlink/${locationId}`
    );
  }

  updateAddressValidation(
    locationId: number,
    newValue: boolean
  ): Observable<SettingsModel> {
    return this._http
      .post<SettingsModel>(`${this.settingsController}/AddressValidation`, {
        locationId,
        newValue,
      })
      .pipe(map((data) => data));
  }
}
